import { render } from "./AboutShort.vue?vue&type=template&id=e28097ba"
import script from "./AboutShort.vue?vue&type=script&lang=js"
export * from "./AboutShort.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__